import { Dispatch, ThunkAction } from '../../../types/actions';
import { fetchHandler } from '../../../util/fetchHandler';
import Util from '../../../util/util';
import { REST_TEMPLATE_POLL_ANSWERS } from '../../constants';
import { getRestHeadersPost } from '../../helpers/getRestHeadersHelper';
import { ITemplatePollAnswers } from './types';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';
import { IGetState, TBoardId } from '../../../types/types';

export const authUserPostTemplatePollAnswers = (
    templateId: TBoardId,
    templateName: string,
    answers: ITemplatePollAnswers,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const { id: userId, email } =  getAuthUser(getState());
        return fetchHandler(Util.getApiUrl(REST_TEMPLATE_POLL_ANSWERS), {
            ...getRestHeadersPost(),
            body: JSON.stringify({
                userId,
                email,
                templateId,
                templateName,
                date: Date.now(),
                answers,
            }),
        });
    }
    return action;
};
